import React from 'react'
import { NormalContainerWithHeader } from './NormalComponent'
import { Avatar, Box, Typography } from '@mui/material'
import { Constants } from '../../constants'
import CustomDivider from '../../utils/CustomDivider'

const NotificationCard = () => {
  return (
    <>
  <NormalContainerWithHeader customPadding={"23px 41px"}>
    <Box sx={{display:"flex",gap:2}}>
        <Avatar src={Constants.customImages.EventAvatar} alt='notification_avatar' sx={{width:"72px",height:"72px"}}/>
    <Box>
        <Typography variant='h5'>Special Event Venue for Apartment</Typography>
        <Typography variant='h6' color='secondary.light' my={0.5}>Just now.</Typography>
        <Typography variant='h5' color='secondary.light'>The scheduled class for C++Prgramming has been rescheduled to 10:30 am. Please adjust your calendar accordingly.</Typography>
    </Box>
    </Box>
  </NormalContainerWithHeader>
  <CustomDivider orientation='horizontal' />
  </>
  )
}

export default NotificationCard